<p-dialog
  [header]="titulo"
  [(visible)]="anularDisplayDialog"
  [modal]="true"
  [closable]="false"
  [closeOnEscape]="true"
  [style]="{ width: '600px', maxWidth: '90vw', maxHeight: '80vh' }"
  [breakpoints]="{ '1200px': '50vw', '768px': '70vw', '480px': '95vw' }"
  role="dialog"
  [attr.aria-labelledby]="'dialog-title'"
  [attr.aria-modal]="true"
>
  <ng-template pTemplate="header">
    <h1 id="dialog-title">{{ titulo }}</h1>
  </ng-template>
  <form [formGroup]="datosAnulacionForm" (ngSubmit)="onSubmitAnular()">
    <div>
      <div class="flex flex-column gap-2 mb-2 compact-field">
        <label for="motivo" class="bold-label">Motivo *</label>
        <textarea
          rows="5"
          cols="30"
          [maxlength]="maxCharacters"
          id="motivo"
          type="text"
          pInputText
          formControlName="motivo"
          autoResize="true"
          autofocus
          [attr.aria-label]="textareaLabel"
          [attr.aria-invalid]="isFieldInvalid"
          [attr.aria-describedby]="'motivo-help character-count'"
          placeholder="Ingrese el motivo de anulación (mínimo {{ minCharacters }} caracteres)"
          [ngClass]="{
            'ng-invalid': isFieldInvalid,
            'minimum-reached': isMinimumReached
          }"
        >
        </textarea>

        <!-- Validación requerido -->
        <small
          *ngIf="
            datosAnulacionForm.get('motivo')?.hasError('required') &&
            datosAnulacionForm.get('motivo')?.touched
          "
          class="p-error"
          role="alert"
        >
          El motivo de anulación es requerido.
        </small>

        <!-- Validación mínimo -->
        <small
          *ngIf="
            datosAnulacionForm.get('motivo')?.hasError('minlength') &&
            datosAnulacionForm.get('motivo')?.touched
          "
          class="p-error"
          role="alert"
        >
          El motivo debe tener al menos {{ minCharacters }} caracteres.
        </small>

        <!-- Validación máximo -->
        <small
          *ngIf="
            datosAnulacionForm.get('motivo')?.hasError('maxlength') &&
            datosAnulacionForm.get('motivo')?.touched
          "
          class="p-error"
          role="alert"
        >
          El motivo no puede tener más de {{ maxCharacters }} caracteres.
        </small>

        <!-- Validación solo espacios -->
        <small
          *ngIf="
            datosAnulacionForm.get('motivo')?.hasError('whitespace') &&
            datosAnulacionForm.get('motivo')?.touched
          "
          class="p-error"
          role="alert"
        >
          El motivo no puede contener solo espacios en blanco.
        </small>

        <!-- Contador con progreso visual -->
        <div class="character-info">
          <small id="character-count">
            {{ caracteresActuales }}/{{ maxCharacters }} caracteres
            <span *ngIf="!isMinimumReached" class="minimum-warning">
              (mínimo {{ minCharacters }})
            </span>
          </small>
          <div class="progress-bar">
            <div
              class="fill"
              [style.width.%]="progressPercentage"
              [ngClass]="{
                'progress-warning': caracteresActuales < minCharacters,
                'progress-success': isMinimumReached && caracteresActuales <= maxCharacters * 0.9,
                'progress-danger': caracteresActuales > maxCharacters * 0.9
              }"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-content-around gap-2">
      <!-- <button
        pButton
        icon="pi pi-times"
        type="button"
        label="Cancelar"
        class="p-button-text p-button-secondary p-button-sm"
        (click)="onCancel()"
      ></button> -->
      <app-action-button
        variant="cancel"
        label="Cancelar"
        [icon]="'pi pi-times'"
        [outlined]="false"
        (buttonClick)="onCancel()"
      >
      </app-action-button>
      <!-- <button
        [disabled]="datosAnulacionForm.invalid"
        pButton
        icon="pi pi-check"
        type="submit"
        label="Confirmar"
        class="p-button-sm"
      ></button> -->
      <app-action-button
        variant="success"
        label="Confirmar"
        [icon]="'pi pi-check'"
        [outlined]="false"
        [disabled]="datosAnulacionForm.invalid"
        [loading]="isProcessing"
        type="submit"
      >
      </app-action-button>
    </div>
  </form>
</p-dialog>
